// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { BrowserMatchReplaceConditionsSchema } from './BrowserMatchReplaceConditionsSchema'
import type { BrowserMatchReplaceConditions } from './BrowserMatchReplaceConditionsSchema'
import { BrowserMatchReplaceRuleSchema } from './BrowserMatchReplaceRuleSchema';

/////////////////////////////////////////
// BROWSER MATCH REPLACE RULE RELATION SCHEMA
/////////////////////////////////////////

export type BrowserMatchReplaceRuleRelations = {
  conditions?: BrowserMatchReplaceConditions | null;
};

export type BrowserMatchReplaceRuleWithRelations = z.infer<typeof BrowserMatchReplaceRuleSchema> & BrowserMatchReplaceRuleRelations

export const BrowserMatchReplaceRuleWithRelationsSchema: z.ZodType<BrowserMatchReplaceRuleWithRelations> = BrowserMatchReplaceRuleSchema.merge(z.object({
  conditions: z.lazy(() => BrowserMatchReplaceConditionsSchema).nullable(),
}))